export default __webpack_public_path__ + "68f1a38f2288333326b6b0c0b89c08b0.png";